var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "profilesTableWrapper", staticClass: "row" },
    [
      _c(
        "div",
        { staticClass: "col-12 card form-box" },
        [
          _c("v-client-table", {
            ref: "client-board-list-view",
            staticClass: "vue-custom-table no-pagination",
            attrs: {
              data: _vm.filteredProfiles,
              columns: _vm.columns,
              options: _vm.tableOptions,
            },
            scopedSlots: _vm._u([
              {
                key: "h__status",
                fn: function () {
                  return [
                    _c("div", { staticClass: "dropdown-filters-wrapper" }, [
                      _c(
                        "a",
                        {
                          staticClass: "clickable",
                          attrs: { "data-toggle": "dropdown" },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("global.words.status")) +
                              "\n            "
                          ),
                          _c("i", {
                            staticClass: "fa fa-filter",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "dropdown-menu" },
                        [
                          _c("client-profiles-filter-dropdown", {
                            attrs: { options: _vm.statusDropdownOptions },
                            on: { input: _vm.handleStatusFilterChange },
                            model: {
                              value: _vm.tableFilters.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.tableFilters, "status", $$v)
                              },
                              expression: "tableFilters.status",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "h__owner",
                fn: function () {
                  return [
                    _c("div", { staticClass: "dropdown-filters-wrapper" }, [
                      _c(
                        "a",
                        {
                          staticClass: "clickable",
                          attrs: { "data-toggle": "dropdown" },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("global.words.owner")) +
                              "\n            "
                          ),
                          _c("i", {
                            staticClass: "fa fa-filter",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "dropdown-menu" },
                        [
                          _c("client-profiles-filter-dropdown", {
                            attrs: { options: _vm.ownerDropdownOptions },
                            model: {
                              value: _vm.tableFilters.owner,
                              callback: function ($$v) {
                                _vm.$set(_vm.tableFilters, "owner", $$v)
                              },
                              expression: "tableFilters.owner",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "h__collaborators",
                fn: function () {
                  return [
                    _c("div", { staticClass: "dropdown-filters-wrapper" }, [
                      _c(
                        "a",
                        {
                          staticClass: "clickable",
                          attrs: { "data-toggle": "dropdown" },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$tc("global.doorr.collaborators", 2)) +
                              "\n            "
                          ),
                          _c("i", {
                            staticClass: "fa fa-filter",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "dropdown-menu" },
                        [
                          _c("client-profiles-filter-dropdown", {
                            attrs: {
                              options: _vm.collaboratorsDropdownOptions,
                            },
                            model: {
                              value: _vm.tableFilters.collaborators,
                              callback: function ($$v) {
                                _vm.$set(_vm.tableFilters, "collaborators", $$v)
                              },
                              expression: "tableFilters.collaborators",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "h__appType",
                fn: function () {
                  return [
                    _c("div", { staticClass: "dropdown-filters-wrapper" }, [
                      _c(
                        "a",
                        {
                          staticClass: "clickable",
                          attrs: { "data-toggle": "dropdown" },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("boards.messages.appType")) +
                              "\n            "
                          ),
                          _c("i", {
                            staticClass: "fa fa-filter",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "dropdown-menu" },
                        [
                          _c("client-profiles-filter-dropdown", {
                            attrs: {
                              options: _vm.applicationFlowDropdownOptions,
                            },
                            model: {
                              value: _vm.tableFilters.applicationFlow,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.tableFilters,
                                  "applicationFlow",
                                  $$v
                                )
                              },
                              expression: "tableFilters.applicationFlow",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "name",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", {
                      domProps: { innerHTML: _vm._s(_vm.formatName(row)) },
                    }),
                  ]
                },
              },
              {
                key: "status",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("h4", { staticClass: "regular text-gray m-0" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.formatStatus(row.status)) +
                          "\n        "
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "owner",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("img", {
                      staticClass: "client-profile-owner-avatar--list mr-2",
                      attrs: {
                        src: _vm.$options.filters.avatarPlaceholder(row.owner),
                        alt: _vm.$t("global.words.profilePhoto"),
                      },
                    }),
                    _vm._v(
                      "\n        " +
                        _vm._s(row.owner.givenName || "") +
                        " " +
                        _vm._s(row.owner.familyName || "") +
                        "\n      "
                    ),
                  ]
                },
              },
              {
                key: "collaborators",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.top.html",
                            value: _vm.formatCollaboratorsTitle(
                              row.collaborators
                            ),
                            expression:
                              "formatCollaboratorsTitle(row.collaborators)",
                            modifiers: { top: true, html: true },
                          },
                        ],
                        staticClass: "thumbnail-group justify-content-center",
                      },
                      _vm._l(
                        _vm.denormalizeCollaborators(row.collaborators),
                        function (collaborator, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "thumbnail-item" },
                            [
                              _c("img", {
                                staticClass: "client-profile-owner-avatar",
                                class: index ? "mr-2" : "",
                                attrs: {
                                  src: _vm.$options.filters.avatarPlaceholder(
                                    collaborator
                                  ),
                                  alt: _vm.$t("global.words.profilePhoto"),
                                },
                              }),
                            ]
                          )
                        }
                      ),
                      0
                    ),
                  ]
                },
              },
              {
                key: "closingDate",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", { staticClass: "d-none" }, [
                      _vm._v(_vm._s(row.closingDate)),
                    ]),
                    _vm._v(" "),
                    row.closingDate
                      ? _c(
                          "h4",
                          {
                            staticClass:
                              "regular text-gray m-0 text-capitalize",
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$options.filters.formatDatepickerDate(
                                    row.closingDate
                                  )
                                ) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
              },
              {
                key: "dateCreated",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", { staticClass: "d-none" }, [
                      _vm._v(_vm._s(row.createdAt)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "h4",
                      { staticClass: "regular text-gray m-0 text-capitalize" },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              row.createdAt
                                ? _vm.$options.filters.formatDatepickerDate(
                                    row.createdAt
                                  )
                                : ""
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "appType",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.formatAppType(row.applicationFlow)) +
                        "\n      "
                    ),
                  ]
                },
              },
              {
                key: "referrerName",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.referrerName != " "
                      ? _c(
                          "h4",
                          {
                            staticClass:
                              "regular text-gray my-auto mx-auto text-capitalize",
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(row.referrerName) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
              },
              {
                key: "nextActivityDate",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", { staticClass: "d-none" }, [
                      _vm._v(_vm._s(row.nextActionDate)),
                    ]),
                    _vm._v(" "),
                    row.nextActionDate
                      ? _c(
                          "h4",
                          {
                            staticClass:
                              "regular text-gray m-0 text-capitalize",
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$options.filters.formatDatepickerDate(
                                    row.nextActionDate
                                  )
                                ) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
              },
              {
                key: "value",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("h4", { staticClass: "regular text-gray m-0" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$options.filters.formatMoneyValue(row.value)
                          ) +
                          "\n        "
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "move",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm transfer-to-board btn-white",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.handleTableClick(row)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("global.words.move")) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("transfer-client-profile-modal", {
        attrs: {
          boards: _vm.boardsWithoutCurrent,
          "client-profile-id": _vm.movingProfile.clientProfileId,
          "client-profile-name": _vm.movingProfile.clientProfileName,
          "status-label-id": _vm.movingProfile.statusLabelId,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }